// Runtime app config resolution.
//
// Precedence: window.__MGR_APP_CONFIG__ (env-config.js, injected per-host) →
// import.meta.env.VITE_MGR_API_BASE (build-time fallback) → default '/api'.
// Mirrors the admin-app window-global-with-env-fallback pattern.

export interface MgrAppConfig {
  apiBase: string;
  appName?: string;
}

declare global {
  interface Window {
    __MGR_APP_CONFIG__?: Partial<MgrAppConfig>;
  }
}

const DEFAULT_API_BASE = '/api';

/**
 * Resolve the serve-manager API base URL.
 * env-config.js wins; then a build-time env var; then the same-origin default.
 */
export function getApiBase(): string {
  const fromConfig = typeof window !== 'undefined' ? window.__MGR_APP_CONFIG__?.apiBase : undefined;
  const fromEnv = import.meta.env.VITE_MGR_API_BASE as string | undefined;
  return fromConfig || fromEnv || DEFAULT_API_BASE;
}

export function getAppName(): string {
  const fromConfig = typeof window !== 'undefined' ? window.__MGR_APP_CONFIG__?.appName : undefined;
  return fromConfig || 'Convenely Manager';
}
